import {
  ScrollView,
  TouchableOpacity,
  Image,
  View,
  Animated,
} from "react-native";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { AppColors } from "../../../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppImages } from "../../../../utility/AppImages";
import { AppScreens } from "../../../Utility/AppScreens";
import * as Clipboard from "expo-clipboard";
import MobileObservePlayer from "../../../../Components/live-streaming-common-components/MobileObservePlayer";
import ObservePlayer from "../../../../Components/live-streaming-common-components/ObservePlayer";
import StreamingView from "../../../../Components/live-streaming-common-components/StreamingView";
import StreamChat from "../../../../Components/live-streaming-common-components/StreamChat";
import AnimatedGift from "../../../../Components/live-streaming-common-components/AnimatedGift";
import MobileGiftBottomSheet from "../../../../Components/live-streaming-common-components/MobileGiftBottomSheet";
import MobileChatBottomSheet from "../../../../Components/live-streaming-common-components/MobileChatBottomSheet";
import TokenPurchaseBottomSheet from "../../../../Components/live-streaming-common-components/TokenPurchaseBottomSheet";
import MobileStreamChat from "../../../../Components/live-streaming-common-components/MobileStreamChat";
import SponsorSection from "../../../../Components/live-streaming-common-components/SponsorSection";
import EventNameSection from "../../../../Components/live-streaming-common-components/EventNameSection";
import VotePopup from "../../../../Components/decideTheWinnerPopup";
import DisputeResolutionModal from "../../../../Components/live-streaming-common-components/DisputeResolutionModal";
import StreamActionIcon from "../../../../Components/StreamActionIcons";
import { giftData } from "../../../../Api/configs";
import { useLiveStream } from "../../../../context/LiveStreamContext";
import { getLoginData } from "../../../../utility/AppStoreData";
import { developUrl } from "../../../../utility/Index";
import { toast } from "react-toastify";
import { fetchEventDetails } from "../../../../services/eventsAPI";
import LiveStremObserverPlayerSkeleton from "../../../../Components/skeleton-components/LiveStremObserverPlayerSkeleton";
import LiveStremObserverChatSkeleton from "../../../../Components/skeleton-components/LiveStremObserverChatSkeleton";
import LiveStreamScreenSkeleton from "../../../../Components/skeleton-components/LiveStreamScreenSkeleton";
import LiveStreamHeaderSkeleton from "../../../../Components/skeleton-components/LiveStreamHeaderSkeleton";
import { TouchableWithoutFeedback } from "react-native";
import Header from "../Common/Header";
import WinnerModal from "../Modals/WinnerModal";
import InviteSocialMediaModal from "../../Event/InviteSocialMediaModal";
import { handleStreamParticipationReward } from "../../../../services/stream";
import { STREAM_STATUS } from "../../../../utility/LiveStreamSocket/LiveStreamConfig";

// Import our new utilities
import {
  useDeviceBreakpoints,
  useGiftAnimations,
  useErrorHandler,
  useCleanupTimers,
  usePlayerData,
} from "./LiveStreaming/hooks";
import { handleError, validateGiftSending } from "./LiveStreaming/utils";
import { SOCIAL_MEDIA_OPTIONS } from "./LiveStreaming/constants";
import { LiveStreamingProps } from "./LiveStreaming/types";
import { useAudienceSocket } from "../../../../utility/hooks/useAudienceSocket";

export default function LiveStreaming({ route }: LiveStreamingProps) {
  const { eventId } = route.params || { eventId: "70a626b424aa029e" };
  const {
    connectToEvent,
    audienceData,
    setUserData,
    sendGift,
    currentEventId,
    setAudienceData,
    setOrganizerData,
    setTotalGiftedTokens,
    userData,
    setEventDate,
    loader,
    setLoader,
    sendLike,
    alreadyLiked,
  } = useLiveStream();

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const { isMobile } = useDeviceBreakpoints();
  useErrorHandler();
  const navigation = useNavigation();

  // Component state
  const [isTeam, setIsTeam] = useState("Team1");
  const [isGiftModal, setIsGiftModal] = useState(false);
  const [inviteSocialMediaModal, setInviteSocialMediaModal] = useState(false);
  const [selectedGiftId, setSelectedGiftId] = useState<string | null>(null);

  // Timer state - set to true when countdown reaches 0
  const [timerHasEnded, setTimerHasEnded] = useState(false);

  // Legacy eventHasStarted from audienceData (fallback)
  const legacyEventHasStarted =
    audienceData?.eventDetails?.streamStatus?.organiser === STREAM_STATUS.LIVE;

  // Default to first player on mobile before event starts, "both" after event starts
  const [selectedPlayer, setSelectedPlayer] = useState(
    isMobile && !legacyEventHasStarted ? "" : "both"
  );
  const [getTokenPopup, setGetTokenPopup] = useState(false);
  const [showWinnerModal, setShowWinnerModal] = useState(false);
  const [showVotePopup, setShowVotePopup] = useState(false);
  const [isVoted, setIsVoted] = useState(false);
  const [chatOpen, setChatOpen] = useState(true);

  // Mobile bottom sheet states
  const [showMobileGiftSheet, setShowMobileGiftSheet] = useState(false);
  const [showMobileChatSheet, setShowMobileChatSheet] = useState(false);
  const [showTokenPurchaseSheet, setShowTokenPurchaseSheet] = useState(false);

  // Like animation states
  const likeTimerRef = useRef<NodeJS.Timeout | null>(null);
  const likeOpacity = useRef(new Animated.Value(0)).current;
  const [selectedTokenPackage, setSelectedTokenPackage] = useState<{
    tokens: number;
    price: string;
    exchangeRate: string;
  } | null>(null);

  // Player selection modal states
  const [showPlayerSelectionModal, setShowPlayerSelectionModal] =
    useState(false);
  const [selectedPlayerForGift, setSelectedPlayerForGift] = useState<
    string | null
  >(null);
  const [pendingGift, setPendingGift] = useState<any>(null);

  // Custom hooks
  const { playerData, setPlayerData } = usePlayerData(selectedPlayer);

  // EventSocket integration for real-time stream status
  const {
    isOrganiserLive: socketOrganiserLive,
    isChallengerLive: socketChallengerLive,
    isOrganiserPaused: socketOrganiserPaused,
    isChallengerPaused: socketChallengerPaused,
    organiserStatus: socketOrganiserStatus,
    challengerStatus: socketChallengerStatus,
    fetchStatus: refetchSocketStatus,
  } = useAudienceSocket({
    eventId: eventId || "",
    userId: userData?.userID || "",
    accessToken: userData?.AccessToken,
    enabled: !!userData?.userID, // Only connect after user data is loaded
  });

  // Use socket status as primary source if available, fallback to audienceData
  const socketEventHasStarted = socketOrganiserLive || socketChallengerLive;

  // Combined eventHasStarted: prioritize socket status, fallback to legacy
  const eventHasStarted = socketEventHasStarted || legacyEventHasStarted;

  // Determine which players should be shown based on socket status
  const showOrganiserPlayer =
    timerHasEnded && (socketOrganiserLive || socketOrganiserPaused);
  const showChallengerPlayer =
    timerHasEnded && (socketChallengerLive || socketChallengerPaused);
  const canSwitchPlayers =
    timerHasEnded && (showOrganiserPlayer || showChallengerPlayer);

  // Player render keys for forcing reload after socket events
  const [organiserRenderKey, setOrganiserRenderKey] = useState(0);
  const [challengerRenderKey, setChallengerRenderKey] = useState(0);
  const retryTimeoutsRef = useRef<NodeJS.Timeout[]>([]);
  const prevOrganiserStatusRef = useRef(socketOrganiserStatus);
  const prevChallengerStatusRef = useRef(socketChallengerStatus);

  // Watch organiser status changes and trigger player reload with retry logic
  useEffect(() => {
    const prevStatus = prevOrganiserStatusRef.current;

    const clearRetryTimeouts = () => {
      retryTimeoutsRef.current.forEach((timeout) => clearTimeout(timeout));
      retryTimeoutsRef.current = [];
    };

    // Reload player when organiser goes live or reconnects (after timer ends)
    if (
      (timerHasEnded &&
        prevStatus !== "live" &&
        socketOrganiserStatus === "live") ||
      (prevStatus === "paused" && socketOrganiserStatus === "live")
    ) {
      console.log(
        "[LiveStreaming] Organiser went live - starting reload sequence"
      );

      clearRetryTimeouts();

      // Reload at 7s interval to handle stream propagation delay
      const retryIntervals = [7000];
      retryIntervals.forEach((delay, index) => {
        const timeout = setTimeout(() => {
          console.log(
            `[LiveStreaming] Organiser retry reload #${index + 1} at ${
              delay / 1000
            }s`
          );
          toast.info("Refreshing organiser stream...");
          setOrganiserRenderKey((prev) => prev + 1);
        }, delay);
        retryTimeoutsRef.current.push(timeout);
      });
    }

    // Clear timeouts if organiser goes offline/paused
    if (socketOrganiserStatus !== "live" && prevStatus === "live") {
      clearRetryTimeouts();
    }

    prevOrganiserStatusRef.current = socketOrganiserStatus;
  }, [socketOrganiserStatus, timerHasEnded]);

  // Watch challenger status changes and trigger player reload with retry logic
  useEffect(() => {
    const prevStatus = prevChallengerStatusRef.current;

    const clearRetryTimeouts = () => {
      retryTimeoutsRef.current.forEach((timeout) => clearTimeout(timeout));
      retryTimeoutsRef.current = [];
    };

    // Reload player when challenger goes live or reconnects (after timer ends)
    if (
      (timerHasEnded &&
        prevStatus !== "live" &&
        socketChallengerStatus === "live") ||
      (prevStatus === "paused" && socketChallengerStatus === "live")
    ) {
      console.log(
        "[LiveStreaming] Challenger went live - starting reload sequence"
      );

      clearRetryTimeouts();

      // Reload at 7s interval to handle stream propagation delay
      const retryIntervals = [7000];
      retryIntervals.forEach((delay, index) => {
        const timeout = setTimeout(() => {
          console.log(
            `[LiveStreaming] Challenger retry reload #${index + 1} at ${
              delay / 1000
            }s`
          );
          toast.info("Refreshing challenger stream...");
          setChallengerRenderKey((prev) => prev + 1);
        }, delay);
        retryTimeoutsRef.current.push(timeout);
      });
    }

    // Clear timeouts if challenger goes offline/paused
    if (socketChallengerStatus !== "live" && prevStatus === "live") {
      clearRetryTimeouts();
    }

    prevChallengerStatusRef.current = socketChallengerStatus;
  }, [socketChallengerStatus, timerHasEnded]);

  // Cleanup retry timeouts on unmount
  useEffect(() => {
    return () => {
      retryTimeoutsRef.current.forEach((timeout) => clearTimeout(timeout));
    };
  }, []);

  // Refs for cleanup
  const rewardTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  useCleanupTimers(rewardTimeoutRef);

  // Cleanup like timer on unmount
  useEffect(() => {
    return () => {
      if (likeTimerRef.current) {
        clearTimeout(likeTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isMobile && eventHasStarted && selectedPlayer === "") {
      setSelectedPlayer("both");
    }
  }, [isMobile, eventHasStarted, selectedPlayer]);

  const giftList = useMemo(() => {
    const gifts = audienceData?.gifts;
    if (!gifts || gifts.length === 0) return [];

    const giftCounts: Record<string, any> = {};
    gifts.forEach((gift: any) => {
      const matchingGift = giftData.find(
        (item) => item.giftName === gift.giftId
      );
      if (!matchingGift) return;

      const allOrNothing = audienceData?.eventDetails?.allOrNothing;
      const key =
        allOrNothing || selectedPlayer === "both"
          ? gift.giftId
          : gift.receiverId === selectedPlayer
          ? `${gift.giftId}-${gift.receiverId}`
          : null;

      if (!key) return;
      if (giftCounts[key]) {
        giftCounts[key].quantity += 1;
      } else {
        giftCounts[key] = { ...gift, quantity: 1, image: matchingGift.gift };
      }
    });

    return Object.values(giftCounts);
  }, [
    audienceData?.gifts,
    audienceData?.eventDetails?.allOrNothing,
    selectedPlayer,
  ]);

  // Avatar positions and gift animations
  const [avatarPositions, setAvatarPositions] = useState({});
  const { animatedGifts, triggerGiftAnimation, removeAnimatedGift } =
    useGiftAnimations(selectedPlayer, audienceData, avatarPositions);

  // Callback to receive avatar positions from child components
  const handleAvatarLayout = useCallback((positions: any) => {
    setAvatarPositions(positions);
  }, []);

  const handleGiftSelect = useCallback(
    (item: any, receiverId?: string | null) => {
      try {
        // Use receiverId if provided, otherwise null (will be handled by validation)
        const finalReceiverId = receiverId !== undefined ? receiverId : null;

        // Validate gift sending - only check receiverId, not selectedPlayer
        validateGiftSending(
          audienceData?.eventDetails?.streamStatus,
          userData?.tokens ?? 0,
          item.price,
          audienceData?.eventDetails?.allOrNothing ?? false,
          finalReceiverId
        );

        const matchingGift = giftData.find(
          (gift) => gift.giftName === item.giftName
        );

        if (!matchingGift) {
          throw new Error("Gift not found in giftData");
        }

        const newGift = {
          eventId: currentEventId,
          giftValue: item.price,
          giftId: item.giftName,
          receiverId: finalReceiverId,
          giftSentId: `gift-${Date.now()}`,
          senderId: userData?.userID,
          status: "unsent",
          createdAt: Date.now(),
          image: matchingGift.gift,
        };

        setAudienceData((prevData: any) => ({
          ...prevData,
          gifts: [...(prevData.gifts || []), newGift],
        }));

        setTotalGiftedTokens((prevTotal: number) => prevTotal + item.price);

        setUserData((prevUserData: any) => ({
          ...prevUserData,
          tokens: Math.max(0, (prevUserData?.tokens ?? 0) - item.price),
        }));

        const giftContent = {
          name: item.giftName,
          value: item.price,
        };

        triggerGiftAnimation(item);
        sendGift(giftContent, finalReceiverId);
      } catch (error: any) {
        if (error.message.includes("Insufficient tokens")) {
          setGetTokenPopup(true);
        }
        handleError(error.message);
      }
    },
    [
      audienceData?.eventDetails?.allOrNothing,
      audienceData?.eventDetails?.streamStatus,
      currentEventId,
      sendGift,
      setAudienceData,
      setTotalGiftedTokens,
      setUserData,
      userData?.tokens,
      userData?.userID,
      triggerGiftAnimation,
      handleError,
    ]
  );

  // Handle gift click - show player selection modal immediately
  const handleGiftClick = useCallback(
    (giftId: string | null) => {
      setSelectedGiftId(giftId);

      // Always show player selection modal when gift is clicked (unless allOrNothing mode)
      if (giftId && !audienceData?.eventDetails?.allOrNothing) {
        const gift = giftData.find((g) => String(g.id) === String(giftId));
        setPendingGift(gift);
        setShowPlayerSelectionModal(true);
      }
    },
    [audienceData?.eventDetails?.allOrNothing, giftData]
  );

  // Handle player selection from modal
  const handlePlayerSelection = useCallback((playerId: string) => {
    setSelectedPlayerForGift(playerId);
  }, []);

  // Handle send button from modal
  const handleSendFromModal = useCallback(() => {
    if (pendingGift && selectedPlayerForGift) {
      handleGiftSelect(pendingGift, selectedPlayerForGift);
      setShowPlayerSelectionModal(false);
      setSelectedPlayerForGift(null);
      setPendingGift(null);
      setSelectedGiftId(null);
    }
  }, [pendingGift, selectedPlayerForGift, handleGiftSelect]);

  const handleCancelModal = useCallback(() => {
    console.log("Gift sending cancelled from modal");
    setShowPlayerSelectionModal(false);
    setSelectedPlayerForGift(null);
    setPendingGift(null);
    setSelectedGiftId(null);
  }, []);

  const socialMediaOptions = useMemo(
    () =>
      SOCIAL_MEDIA_OPTIONS.map((option) => ({
        ...option,
        image: {
          Instagram: AppImages.icSocialInsta,
          Whatsapp: AppImages.icSocialWhatsapp,
          Twitter: AppImages.icSocialTwitter,
          Facebook: AppImages.icSocialFacebook,
        }[option.name],
      })),
    []
  );

  useEffect(() => {
    const initializeLiveStream = async () => {
      try {
        const loginData = await getLoginData();
        if (!loginData) {
          handleError("No login data found", false);
          return;
        }

        setUserData(loginData);
        setLoader(true);

        const response = await fetchEventDetails(
          eventId,
          loginData.AccessToken,
          "true"
        );

        if (!response) {
          handleError("No response from fetchEventDetails", false);
          return;
        }

        const { EventDate } = response;
        const eventDateTime = new Date(EventDate);
        const currentDateTime = new Date();

        if (
          isNaN(eventDateTime.getTime()) ||
          isNaN(currentDateTime.getTime())
        ) {
          handleError("Invalid EventDate or currentDateTime", false);
          return;
        }

        setEventDate(EventDate);

        const timeDifferenceInHours =
          (eventDateTime.getTime() - currentDateTime.getTime()) /
          (1000 * 60 * 60);
        if (timeDifferenceInHours > 1) {
          navigateToScreen(navigation, AppScreens.GameShowScreen, {
            eventID: eventId,
          });
        } else {
          connectToEvent(
            loginData.username,
            eventId,
            loginData.AccessToken,
            "audience"
          );
        }
      } catch (error: any) {
        handleError(`Error in initializeLiveStream: ${error.message}`, false);
      }
    };

    initializeLiveStream();
  }, [eventId, handleError]);

  const organiserIsLive =
    audienceData?.eventDetails?.streamStatus?.organiser === STREAM_STATUS.LIVE;
  useEffect(() => {
    if (!organiserIsLive) return;
    const timer = setTimeout(async () => {
      try {
        const loginData = await getLoginData();
        await handleStreamParticipationReward(
          loginData?.AccessToken,
          audienceData?.eventDetails?.eventID
        );
      } catch (error) {
        console.error("Error calling reward API:", error);
      }
    }, 60000);

    return () => clearTimeout(timer);
  }, [organiserIsLive]);

  const getShareUrl = useCallback(() => {
    return `${developUrl}/LiveStreaming?eventId=${currentEventId}`;
  }, [currentEventId]);

  const shareOnPlatform = useCallback(
    (platform) => {
      const url = getShareUrl();

      let shareUrl = "";

      switch (platform) {
        case "Whatsapp":
          shareUrl = `https://wa.me/?text=${encodeURIComponent(url)}`;
          break;
        case "Instagram":
          shareUrl = `instagram://sharesheet?text=${encodeURIComponent(url)}`;
          break;
        case "Twitter":
          shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
            url
          )}`;
          break;
        case "Facebook":
          const message = `Check out this link: ${encodeURIComponent(url)}`;
          shareUrl = `https://www.messenger.com/t/?message=${encodeURIComponent(
            message
          )}`;
          break;
        default:
          break;
      }
      if (shareUrl) {
        window.open(shareUrl, "_blank");
      }
    },
    [getShareUrl]
  );

  const copyToClipboard = useCallback(async () => {
    try {
      const linkToCopy = getShareUrl();
      await Clipboard.setStringAsync(linkToCopy);
      toast.success("Link copied to clipboard");
    } catch (error) {
      console.error("Error copying to clipboard:", error);
    }
  }, [getShareUrl]);

  const { eventDetails, participantDetails, winnerDetails } = audienceData;

  useEffect(() => {
    if (!eventDetails) return;

    if (
      eventDetails.publicVotingEnabled &&
      eventDetails.resultStatus?.winner === null
    ) {
      if (!eventDetails.hasVoted) {
        setShowVotePopup(true);
      } else {
        setIsVoted(true);
      }
    } else {
      setIsVoted(false);
    }
  }, [audienceData.eventDetails]);

  useEffect(() => {
    if (winnerDetails) {
      if (winnerDetails.username) {
        setShowWinnerModal(true);
      } else {
        setShowWinnerModal(false);
      }
    }
  }, [winnerDetails]);

  // Handle insufficient tokens on mobile - auto-open token purchase sheet
  useEffect(() => {
    if (isMobile && getTokenPopup) {
      setShowMobileGiftSheet(false);
      setShowTokenPurchaseSheet(true);
      setGetTokenPopup(false);
    }
  }, [getTokenPopup, isMobile]);

  const organizer =
    participantDetails?.find(
      (participant) => participant.userID === eventDetails?.organiserId
    ) || {};

  const challenger =
    participantDetails?.find(
      (participant) => participant.userID !== eventDetails?.organiserId
    ) || {};

  const organizerName = organizer?.userID || "Player 1";
  const challengerName = challenger?.userID || "Player 2";

  const handleOutsideClick = useCallback(() => {
    if (isGiftModal) {
      setIsGiftModal(false);
    }
  }, [isGiftModal]);
  return (
    <TouchableWithoutFeedback onPress={handleOutsideClick}>
      <View
        style={{
          flex: 1,
          backgroundColor: "#000000",
        }}
      >
        <Header
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
          }}
          btnWalletTapped={() => {}}
          btnStartTutorialTapped={() => {}}
          btnMessageTapped={() => {}}
          btnNotificationTapped={() => {}}
          btnProfileTapped={() => {}}
        />
        <View
          style={
            isMobile
              ? {
                  flex: 1,
                  marginBottom: isMobile && selectedPlayer !== "both" ? 0 : 55,
                }
              : { flex: 1 }
          }
        >
          {isMobile && selectedPlayer !== "both" ? (
            // Mobile Single Player - No ScrollView, flex layout
            <View style={{ flex: 1, flexDirection: "column" }}>
              <View>
                {/* Event Name Section - Mobile */}
                {!loader && (
                  <EventNameSection
                    onTimerEnd={() => {
                      setTimerHasEnded(true);
                      refetchSocketStatus();
                    }}
                  />
                )}
                {/* Sponsor Section */}
                {loader ? (
                  <View
                    style={{
                      backgroundColor: "#000",
                      borderRadius: 6.339,
                      borderTopWidth: 0.634,
                      borderBottomWidth: 0.634,
                      borderTopColor: "rgba(255, 255, 255, 0.40)",
                      borderBottomColor: "rgba(255, 255, 255, 0.40)",
                      height: 45,
                      justifyContent: "center",
                      paddingHorizontal: 10,
                      paddingVertical: 2,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-around",
                        alignItems: "center",
                      }}
                    >
                      {[1, 2, 3].map((item) => (
                        <View
                          key={item}
                          style={{
                            width: 100,
                            height: 40,
                            backgroundColor: "#2a2a2a",
                            borderRadius: 6,
                          }}
                        />
                      ))}
                    </View>
                  </View>
                ) : (
                  <SponsorSection />
                )}
                {/* Mobile Player and Stream */}
                {loader ? (
                  <>
                    <LiveStremObserverPlayerSkeleton />
                    <LiveStreamScreenSkeleton />
                  </>
                ) : (
                  <>
                    <MobileObservePlayer
                      playerData={playerData}
                      selectedPlayer={selectedPlayer}
                      setSelectedPlayer={setSelectedPlayer}
                      setPlayerData={setPlayerData}
                      onAvatarLayout={handleAvatarLayout}
                    />
                    <StreamingView
                      styles={styles}
                      selectedPlayer={selectedPlayer}
                      giftData={giftData}
                      selectedGiftId={selectedGiftId}
                      setSelectedGiftId={handleGiftClick}
                      handleGiftSelect={handleGiftSelect}
                      chatOpen={chatOpen}
                      getTokenPopup={getTokenPopup}
                      setGetTokenPopup={setGetTokenPopup}
                      isVoted={isVoted}
                      isMobile={isMobile}
                      onOpenMobileGiftSheet={() => setShowMobileGiftSheet(true)}
                      showPlayerSelection={showPlayerSelectionModal}
                      onSelectPlayer={handlePlayerSelection}
                      selectedPlayerForGift={selectedPlayerForGift}
                      onSendGift={handleSendFromModal}
                      onCancelModal={handleCancelModal}
                      organizer={{
                        userID: organizer?.userID || "",
                        profilePicture: organizer?.profilePicture || "",
                      }}
                      challenger={{
                        userID: challenger?.userID || "",
                        profilePicture: challenger?.profilePicture || "",
                      }}
                      organiserRenderKey={organiserRenderKey}
                      challengerRenderKey={challengerRenderKey}
                    />
                  </>
                )}
              </View>
              {/* Chat takes remaining space */}
              {!loader && (
                <MobileStreamChat
                  onOpenGiftSheet={() => setShowMobileGiftSheet(true)}
                  onOpenShareModal={() => setInviteSocialMediaModal(true)}
                />
              )}
            </View>
          ) : deviceSize === DEVICE_SIZES.XL ? (
            // Web XL - No ScrollView, use flex layout
            <View style={{ flex: 1, flexDirection: "column" }}>
              {/* Unified Header Section */}
              {loader ? (
                <View
                  style={{
                    backgroundColor: "#111827",
                    paddingVertical: 8,
                    paddingHorizontal: 14,
                    minHeight: 65,
                  }}
                >
                  <LiveStreamHeaderSkeleton />
                </View>
              ) : (
                <View
                  style={{
                    backgroundColor: "#111827",
                    paddingVertical: 8,
                    paddingHorizontal: 14,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 15,
                  }}
                >
                  {/* Back Button - Only on Web */}
                  <TouchableOpacity
                    onPress={() => {
                      navigation.dispatch(StackActions.pop());
                    }}
                    style={{
                      padding: 8,
                    }}
                  >
                    <Image
                      source={AppImages.icArrowLeft}
                      style={{ height: 24, width: 24, tintColor: "white" }}
                      resizeMode="contain"
                    />
                  </TouchableOpacity>

                  {/* Event Name and Timer Section */}
                  <View style={{ flex: 1 }}>
                    <EventNameSection
                      transparent={true}
                      onTimerEnd={() => {
                        setTimerHasEnded(true);
                        refetchSocketStatus();
                      }}
                    />
                  </View>
                </View>
              )}

              {/* Sponsor Section */}
              {loader ? (
                <View
                  style={{
                    backgroundColor: "#000",
                    borderRadius: 6.339,
                    borderTopWidth: 0.634,
                    borderBottomWidth: 0.634,
                    borderTopColor: "rgba(255, 255, 255, 0.40)",
                    borderBottomColor: "rgba(255, 255, 255, 0.40)",
                    height: 45,
                    justifyContent: "center",
                    paddingHorizontal: 15,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    {[1, 2, 3, 4, 5].map((item) => (
                      <View
                        key={item}
                        style={{
                          width: 120,
                          height: 40,
                          backgroundColor: "#2a2a2a",
                          borderRadius: 6,
                        }}
                      />
                    ))}
                  </View>
                </View>
              ) : (
                <SponsorSection />
              )}

              {/* Main Content Row - Takes remaining space */}
              {loader ? (
                <View
                  style={[
                    styles.deviceDirection,
                    { flexDirection: "row", flex: 1 },
                  ]}
                >
                  <LiveStremObserverPlayerSkeleton />
                  <LiveStreamScreenSkeleton />
                  {chatOpen && <LiveStremObserverChatSkeleton />}
                </View>
              ) : (
                <View
                  style={[
                    styles.deviceDirection,
                    { flexDirection: "row", flex: 1 },
                  ]}
                >
                  <ObservePlayer
                    styles={styles}
                    chatOpen={chatOpen}
                    setChatOpen={setChatOpen}
                    selectedPlayer={selectedPlayer}
                    isTeam={isTeam}
                    setIsTeam={setIsTeam}
                    playerData={playerData}
                    setSelectedPlayer={setSelectedPlayer}
                    setPlayerData={setPlayerData}
                    giftList={giftList}
                    onAvatarLayout={handleAvatarLayout}
                  />
                  <StreamingView
                    styles={styles}
                    selectedPlayer={selectedPlayer}
                    giftData={giftData}
                    selectedGiftId={selectedGiftId}
                    setSelectedGiftId={handleGiftClick}
                    handleGiftSelect={handleGiftSelect}
                    chatOpen={chatOpen}
                    getTokenPopup={getTokenPopup}
                    setGetTokenPopup={setGetTokenPopup}
                    isVoted={isVoted}
                    isMobile={isMobile}
                    onOpenMobileGiftSheet={() => setShowMobileGiftSheet(true)}
                    showPlayerSelection={showPlayerSelectionModal}
                    onSelectPlayer={handlePlayerSelection}
                    selectedPlayerForGift={selectedPlayerForGift}
                    onSendGift={handleSendFromModal}
                    onCancelModal={handleCancelModal}
                    organizer={{
                      userID: organizer?.userID || "",
                      profilePicture: organizer?.profilePicture || "",
                    }}
                    challenger={{
                      userID: challenger?.userID || "",
                      profilePicture: challenger?.profilePicture || "",
                    }}
                    organiserRenderKey={organiserRenderKey}
                    challengerRenderKey={challengerRenderKey}
                  />
                  {chatOpen && (
                    <StreamChat
                      styles={styles}
                      setInviteSocialMediaModal={setInviteSocialMediaModal}
                      setIsGiftModal={setIsGiftModal}
                      inviteSocialMediaModal={inviteSocialMediaModal}
                      giftData={giftData}
                      isGiftModal={isGiftModal}
                      socialMediaOptions={socialMediaOptions}
                      shareOnPlatform={shareOnPlatform}
                      copyToClipboard={copyToClipboard}
                      handleGiftSelect={handleGiftSelect}
                      getTokenPopup={getTokenPopup}
                      setGetTokenPopup={setGetTokenPopup}
                      isMobile={isMobile}
                      onOpenMobileGiftSheet={() => setShowMobileGiftSheet(true)}
                    />
                  )}
                </View>
              )}
            </View>
          ) : (
            // Mobile/Tablet - use ScrollView
            <>
              {/* Sponsor Section - Mobile/Tablet only */}
              {loader ? (
                <View
                  style={{
                    backgroundColor: "#000",
                    borderRadius: 6.339,
                    borderTopWidth: 0.634,
                    borderBottomWidth: 0.634,
                    borderTopColor: "rgba(255, 255, 255, 0.40)",
                    borderBottomColor: "rgba(255, 255, 255, 0.40)",
                    height: 45,
                    justifyContent: "center",
                    paddingHorizontal: 10,
                    paddingVertical: 2,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    {[1, 2, 3].map((item) => (
                      <View
                        key={item}
                        style={{
                          width: 100,
                          height: 40,
                          backgroundColor: "#2a2a2a",
                          borderRadius: 6,
                        }}
                      />
                    ))}
                  </View>
                </View>
              ) : (
                <SponsorSection />
              )}
              <ScrollView
                style={styles.container}
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={{
                  flexGrow: 1,
                }}
              >
                <View
                  style={{
                    padding: 0,
                  }}
                >
                  {/* Event Name Section - Mobile/Tablet only */}
                  {!loader && (
                    <EventNameSection
                      onTimerEnd={() => {
                        setTimerHasEnded(true);
                        refetchSocketStatus();
                      }}
                    />
                  )}
                </View>

                {/* Mobile/Tablet Layout - Show StreamChat at bottom when single player selected */}
                <View style={{ flexDirection: "column" }}>
                  {loader ? (
                    <LiveStremObserverPlayerSkeleton />
                  ) : (
                    <MobileObservePlayer
                      playerData={playerData}
                      selectedPlayer={selectedPlayer}
                      setSelectedPlayer={setSelectedPlayer}
                      setPlayerData={setPlayerData}
                      onAvatarLayout={handleAvatarLayout}
                    />
                  )}
                  {loader ? (
                    <LiveStreamScreenSkeleton />
                  ) : (
                    <StreamingView
                      styles={styles}
                      selectedPlayer={selectedPlayer}
                      giftData={giftData}
                      selectedGiftId={selectedGiftId}
                      setSelectedGiftId={handleGiftClick}
                      handleGiftSelect={handleGiftSelect}
                      chatOpen={chatOpen}
                      getTokenPopup={getTokenPopup}
                      setGetTokenPopup={setGetTokenPopup}
                      isVoted={isVoted}
                      isMobile={isMobile}
                      onOpenMobileGiftSheet={() => setShowMobileGiftSheet(true)}
                      showPlayerSelection={showPlayerSelectionModal}
                      onSelectPlayer={handlePlayerSelection}
                      selectedPlayerForGift={selectedPlayerForGift}
                      onSendGift={handleSendFromModal}
                      onCancelModal={handleCancelModal}
                      organizer={{
                        userID: organizer?.userID || "",
                        profilePicture: organizer?.profilePicture || "",
                      }}
                      challenger={{
                        userID: challenger?.userID || "",
                        profilePicture: challenger?.profilePicture || "",
                      }}
                      organiserRenderKey={organiserRenderKey}
                      challengerRenderKey={challengerRenderKey}
                    />
                  )}
                </View>
              </ScrollView>
            </>
          )}
        </View>

        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: "none",
            zIndex: 1000,
          }}
        >
          {animatedGifts.map((gift) => (
            <AnimatedGift
              key={gift.id}
              giftImage={gift.giftImage}
              startPosition={gift.startPosition}
              endPosition={gift.endPosition}
              playerIndex={gift.playerIndex}
              onAnimationComplete={() => removeAnimatedGift(gift.id)}
              duration={1500}
            />
          ))}
        </View>

        {showWinnerModal && (
          <WinnerModal
            closeWinnerModal={() => setShowWinnerModal(false)}
            openWinnerModal={showWinnerModal}
            eventDetails={eventDetails}
            winnerDetails={audienceData.winnerDetails}
          />
        )}

        {/* Social Media Share Modal */}
        {inviteSocialMediaModal && (
          <InviteSocialMediaModal
            accessToken={""}
            challengeDetails={{}}
            showModal={inviteSocialMediaModal}
            setShowModal={setInviteSocialMediaModal}
            eventType={"LiveStreaming"}
            eventID={""}
            status={""}
          />
        )}

        {showVotePopup && (
          <VotePopup
            visible={showVotePopup}
            onClose={() => setShowVotePopup(false)}
            eventDetails={eventDetails}
            pollEndTime={eventDetails?.pollEndTime || "2025-02-18T20:00:00Z"}
            setIsVoted={setIsVoted}
          />
        )}

        {/* {audienceData?.eventDetails?.resultStatus?.dispute && (
          <DisputeResolutionModal
            visible={true}
            eventDetails={eventDetails}
            disputeEndTime="00:04:00"
          />
        )} */}

        {/* Three Floating Action Buttons - Only show when both players selected (Mobile Only) */}
        {isMobile && selectedPlayer === "both" && (
          <View
            style={{
              position: "absolute",
              bottom: 5, // Move up to fit above tab bar
              right: 20,
              left: 20,
              flexDirection: "row",
              justifyContent: "center",
              gap: 12,
              zIndex: 999,
              backgroundColor: "rgba(0, 0, 0, 0.1)", // Subtle background
              borderRadius: 30,
              paddingVertical: 4,
              paddingHorizontal: 8,
            }}
          >
            {/* Chat Button */}
            <StreamActionIcon
              type="chat"
              onPress={() => setShowMobileChatSheet(true)}
            />

            {/* Gift Button */}
            <StreamActionIcon
              type="gift"
              onPress={() => setShowMobileGiftSheet(true)}
            />

            {/* Share Button */}
            <StreamActionIcon
              type="share"
              onPress={() => setInviteSocialMediaModal(true)}
            />
          </View>
        )}

        {/* Mobile Bottom Sheets */}
        {isMobile && (
          <>
            <MobileChatBottomSheet
              visible={showMobileChatSheet}
              onClose={() => setShowMobileChatSheet(false)}
              sendLike={sendLike}
              alreadyLiked={alreadyLiked}
              setOrganizerData={setOrganizerData}
              setAudienceData={setAudienceData}
            />

            <MobileGiftBottomSheet
              visible={showMobileGiftSheet}
              onClose={() => setShowMobileGiftSheet(false)}
              giftData={giftData}
              handleGiftSelect={handleGiftSelect}
              onOpenTokenPurchase={() => {
                setShowMobileGiftSheet(false);
                setShowTokenPurchaseSheet(true);
              }}
              player1={{
                userID: organizer?.userID || "",
                name: organizerName,
                image: organizer?.profilePicture || "",
              }}
              player2={{
                userID: challenger?.userID || "",
                name: challengerName,
                image: challenger?.profilePicture || "",
              }}
              isAllOrNothing={audienceData?.eventDetails?.allOrNothing || false}
            />

            <TokenPurchaseBottomSheet
              visible={showTokenPurchaseSheet}
              onClose={() => {
                setShowTokenPurchaseSheet(false);
                setSelectedTokenPackage(null);
              }}
              tokenPackages={[
                // { tokens: 28, price: "£0.29", exchangeRate: "£0.01" },
                { tokens: 88, price: "£0.90", exchangeRate: "£0.01" },
                { tokens: 577, price: "£5.99", exchangeRate: "£0.01" },
                { tokens: 1127, price: "£12.79", exchangeRate: "£0.01" },
                { tokens: 2227, price: "£26.29", exchangeRate: "£0.01" },
                { tokens: 4427, price: "£52.99", exchangeRate: "£0.01" },
                { tokens: 8827, price: "£106.79", exchangeRate: "£0.01" },
                { tokens: 20327, price: "£246.99", exchangeRate: "£0.01" },
              ]}
              selectedPackage={selectedTokenPackage}
              handlePackageSelect={setSelectedTokenPackage}
            />
          </>
        )}
      </View>
    </TouchableWithoutFeedback>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
    },
    socialIcon: {
      width: 31,
      height: 32,
      resizeMode: "contain",
    },
    observePlayerView: {
      marginLeft: 15,
      width: "20%",
    },
    socialIconContainer: {
      alignItems: "center",
      marginVertical: 5,
    },
    btnTeam: {
      paddingVertical: 15,
      paddingHorizontal: 20,
      margin: 10,
    },
    streamChatView: {
      width: "20%",
    },
    timeContainer: {
      flexDirection: "row",
      columnGap: 15,
      justifyContent: "center",
    },
    btnStyle: {
      paddingVertical: 0,
      paddingHorizontal: 100,
      backgroundColor: AppColors.koBrandRed,
      shadowOpacity: 0,
      height: 40,
      alignSelf: "center",
      borderRadius: 12,
      marginTop: 10,
    },
    imageView: {
      width: 51,
      height: 51,
      borderRadius: 100,
      borderColor: AppColors.koBrandRed,
      borderWidth: 1,
    },
    textInput: {
      width: "80%",
      backgroundColor: "white",
      borderRadius: 10,
      paddingHorizontal: 5,
      paddingVertical: 11,
      justifyContent: "center",
      alignItems: "center",
      color: "black",
      // marginEnd: 10
    },
    deviceDirection: {
      flexDirection: "row",
    },
    copyLinkContainer: {
      flexDirection: "row",
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      padding: 16,
      borderRadius: 10,
      marginBottom: 10,
      marginTop: 10,
      alignItems: "center",
    },
    linkIcon: {
      height: 20,
      width: 20,
      resizeMode: "contain",
    },
    scrollView: {
      height: 204,
    },
    gridContainer: {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      paddingHorizontal: 5,
      paddingVertical: 10,
      gap: 30,
      paddingLeft: 22,
    },
    itemContainer: {
      width: 92,
      borderRadius: 8,
      elevation: 5,
    },
    giftContent: {
      padding: 12,
      alignItems: "center",
    },
    imageContainer: {
      backgroundColor: AppColors.gary_4E4E4E,
      height: 64,
      width: 66,
      justifyContent: "center",
      alignItems: "center",
      marginBottom: 5,
    },
    giftImage: {
      height: 35,
      width: 35,
      marginTop: 3,
    },
    sideGiftImage: {
      height: 35,
      width: 35,
      marginTop: 3,
    },
    giftName: {
      width: "100%",
      textAlign: "center",
      fontSize: 8,
      color: AppColors.white,
      marginTop: 3,
    },
    priceContainer: {
      flexDirection: "row",
      justifyContent: "space-evenly",
      alignItems: "center",
      marginTop: 5,
      paddingVertical: 6,
    },
    priceIcon: {
      height: 19,
      width: 19,
      marginRight: 2,
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        backgroundColor: "transparent",
        flex: 1,
      },
      observePlayerView: {
        width: "100%",
        marginHorizontal: 0,
        paddingHorizontal: 15,
      },
      btnTeam: {
        paddingVertical: 15,
        paddingHorizontal: 32,
        margin: 10,
      },
      streamChatView: {
        marginHorizontal: 15,
        width: "auto",
      },
      gridContainer: {
        gap: 20,
        paddingLeft: 0,
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 100,
        backgroundColor: AppColors.koBrandRed,
        shadowOpacity: 0,
        height: 40,
        alignSelf: "center",
        borderRadius: 12,
        marginTop: 10,
      },
      textInput: {
        width: "80%",
        height: "100%",
        backgroundColor: "white",
        borderRadius: 10,
        paddingHorizontal: 5,
        paddingVertical: 11,
        justifyContent: "center",
        alignItems: "center",
        color: "black",
      },
      deviceDirection: {
        gap: 15,
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        backgroundColor: "transparent",
        flex: 1,
      },
      observePlayerView: {
        width: "100%",
        marginHorizontal: 0,
        paddingHorizontal: 15,
      },
      btnTeam: {
        paddingVertical: 15,
        paddingHorizontal: 32,
        margin: 10,
      },
      streamChatView: {
        marginHorizontal: 15,
        width: "auto",
        marginBottom: 20,
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 100,
        backgroundColor: AppColors.koBrandRed,
        shadowOpacity: 0,
        height: 40,
        alignSelf: "center",
        borderRadius: 12,
        marginTop: 10,
      },
      textInput: {
        width: "80%",
        height: "100%",
        backgroundColor: "white",
        borderRadius: 10,
        paddingHorizontal: 5,
        paddingVertical: 11,
        justifyContent: "center",
        alignItems: "center",
        color: "black",
      },
      deviceDirection: {
        gap: 15,
        flexDirection: "column",
      },
    },

    [DEVICE_SIZES.MD]: {
      container: {
        backgroundColor: "transparent",
        flex: 1,
      },
      observePlayerView: {
        width: "100%",
        marginHorizontal: 15,
      },
      btnTeam: {
        paddingVertical: 15,
        paddingHorizontal: 32,
        margin: 10,
      },
      // streamingVideo: {
      //   width: "100%",
      //   // height:"40%"
      // },
      streamChatView: {
        marginHorizontal: 10,
        width: "95%",
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 100,
        backgroundColor: AppColors.koBrandRed,
        shadowOpacity: 0,
        height: 40,
        alignSelf: "center",
        borderRadius: 12,
        marginTop: 10,
      },
      textInput: {
        width: "80%",
        height: "100%",
        backgroundColor: "white",
        borderRadius: 10,
        paddingHorizontal: 5,
        paddingVertical: 11,
        justifyContent: "center",
        alignItems: "center",
        color: "black",
        // marginEnd: 10
      },
      deviceDirection: {
        gap: 10,
        // gap:"10%",
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        backgroundColor: "transparent",
        flex: 1,
      },
      observePlayerView: {
        width: "100%",
        marginHorizontal: 15,
      },
      btnTeam: {
        paddingVertical: 15,
        paddingHorizontal: 32,
        margin: 10,
      },
      // streamingVideo: {
      //   width: "100%",
      //   // height:"40%"
      // },
      streamChatView: {
        marginHorizontal: 10,
        width: "95%",
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 100,
        backgroundColor: AppColors.koBrandRed,
        shadowOpacity: 0,
        height: 40,
        alignSelf: "center",
        borderRadius: 12,
        marginTop: 10,
      },
      textInput: {
        width: "80%",
        height: "100%",
        backgroundColor: "white",
        borderRadius: 10,
        paddingHorizontal: 5,
        paddingVertical: 11,
        justifyContent: "center",
        alignItems: "center",
        color: "black",
        // marginEnd: 10
      },
      deviceDirection: {
        gap: 10,
        // gap:"10%",
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.XL]: {
      container: {
        backgroundColor: "transparent",
        flex: 1,
      },
      observePlayerView: {
        flex: 0.2,
        marginLeft: 15,
      },
      streamChatView: {
        flex: 0.2,
        marginRight: 15,
      },
      btnTeam: {
        paddingVertical: 15,
        paddingHorizontal: 32,
        margin: 10,
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 100,
        backgroundColor: AppColors.koBrandRed,
        shadowOpacity: 0,
        height: 40,
        alignSelf: "center",
        borderRadius: 12,
        marginTop: 10,
      },
      textInput: {
        width: "80%",
        height: "100%",
        backgroundColor: "white",
        borderRadius: 10,
        paddingHorizontal: 5,
        paddingVertical: 11,
        justifyContent: "center",
        alignItems: "center",
        color: "black",
      },
      deviceDirection: {
        flexDirection: "row",
      },
    },
  }
);
